import {isWebpSupported, executeAndDebounce} from "./modules/functions.js";
isWebpSupported();

function stickyHeader(){
  const header = document.querySelector('.header')
  const scrolledClassName = '_scrolled'
  function foo(){
    if(window.scrollY > 0) {
      header.classList.add(scrolledClassName)
    } else {
      header.classList.remove(scrolledClassName)
    }
  }
  window.addEventListener('scroll', executeAndDebounce(foo, 200))
}
stickyHeader()

import { DynamicAdapt } from "./modules/dynamic-adapt.js";
const da = new DynamicAdapt("max");
da.init();

import { initBurger } from "./modules/burger.js";
initBurger()

const selector = '.signals__chart'
new LazyLoad({
  elements_selector: selector,
  unobserve_entered: true,
  callback_enter: () => {
    import("./modules/chart.js")
      .then(module => module.chart())
      .catch(e => console.log('Failed to load charts', e))
  }
})

new LazyLoad({
  elements_selector: ".signup",
  unobserve_entered: true,
  callback_enter: () => {
    const perkIcons = document.querySelectorAll('.perk__icons')
    for(const perkIcon of perkIcons) {
      const clone = perkIcon.querySelector('img').cloneNode()
      clone.classList.add('perk__icon-shadow')
      perkIcon.insertAdjacentElement('beforeend', clone)
    }
    lazyLoadInstance.update()
  }
})

new LazyLoad({
  elements_selector: ".plans__slider",
  unobserve_entered: true,
  callback_enter: () => {
    // console.log('import plans swiper')
    import("./modules/plans-swiper.js")
      .then(module => module.init())
      .catch(e => console.log('Failed to load plans-swiper.js', e))
  }
})

new LazyLoad({
  elements_selector: ".reviews__slider",
  unobserve_entered: true,
  callback_enter: () => {
    // console.log('import reviews swiper')
    import("./modules/reviews-swiper.js")
      .then(module => module.init())
      .catch(e => console.log('Failed to load reviews-swiper.js', e))
  }
})